import React, { ReactElement, ReactNode } from 'react';
import { useScrollTrigger } from '@mui/material';
import { IconButton, AppBar } from '@qbe/ads-core';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { BrandLogo } from '../../components';
import { useBreakpoint } from '../../hooks/useBreakpoint';

interface childrenProps {
  elevation?: number;
}

interface ElevationScrollProps {
  children: React.ReactElement<childrenProps>;
  window?: () => Node | Window | undefined;
}

interface HeaderProps {
  onBack?: () => void;
  isBackEnabled?: boolean;
  content?: ReactNode;
}

const ElevationScroll = ({ children, window }: ElevationScrollProps) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
};

export default function Header(props: HeaderProps) {
  const { content, onBack, isBackEnabled = false } = props;
  const { isMobile } = useBreakpoint();

  return (
    <>
      <ElevationScroll>
        <AppBar variant="ondark" stepper={content ? (content as ReactElement) : <></>}>
          {isBackEnabled && (
            <IconButton
              style={{ width: isMobile ? '25px' : '35px', height: isMobile ? '25px' : '35px' }}
              onClick={onBack}
              iconProps={{ muiIcon: ChevronLeftIcon, color: 'white', size: isMobile ? 25 : 35 }}
              data-track="back-btn"
              data-test="back-btn"
            />
          )}
        </AppBar>
      </ElevationScroll>
    </>
  );
}
